import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, Subscription, firstValueFrom } from "rxjs";
import { IUserLoginRequest } from "../../models/IUserLoginRequest";
import { NotificationsToastService } from "../../../shared/services/Notifications-Toast.service";
import { MatDialog } from "@angular/material/dialog";
import { SendRecoveryPasswordMailRequest } from "../../models/SendRecoveryPasswordMailRequest.model";
import { SendRecoveryPasswordDialogComponent } from "../../dialog/send-recovery-password-dialog/send-recovery-password-dialog.component";
import { MediaMatcher } from "@angular/cdk/layout";
import { AuthService } from "../../services/Auth.service";
import { EncriptionService } from "src/app/features/shared/services/Encription.service";
@Component({
  selector: "login",
  templateUrl: "./loginPage.component.html",
  styleUrls: ["./loginPage.component.css"],
})
export class LoginPageComponent implements OnInit {
  formLogin: FormGroup;
  public isLoading: boolean = false;
  loginInvalid: boolean;
  resp: boolean;
  hidePassword: boolean = true;
  private config: {version: string}; 

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  subscription_Login: Subscription;
  subscription_GetDataCitronella: Subscription;
  subscription_GetClients: Subscription;
  suscription_checkAuth: Subscription;
  recoveryPasswordRequest = {} as SendRecoveryPasswordMailRequest;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private encriptionService: EncriptionService,
    private notificationsToastService: NotificationsToastService,
    private dialog: MatDialog,
    changeDetectorRef: ChangeDetectorRef, 
    media: MediaMatcher,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 780px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.formLogin = formBuilder.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });

    
  }

  ngOnInit(): void {
    this.config = require('../../../../../assets/config.json'); 
      localStorage.setItem("version", this.config.version);

    this.isLoggedIn();
  }

  ngOnDestroy() {
    if (this.subscription_Login) this.subscription_Login.unsubscribe();
    if (this.subscription_GetDataCitronella) this.subscription_GetDataCitronella.unsubscribe();
    if (this.subscription_GetClients) this.subscription_GetClients.unsubscribe();
    if (this.suscription_checkAuth) this.suscription_checkAuth.unsubscribe();
  }

  Login() {
    this.isLoading= true;
    const usuarioLogin: IUserLoginRequest = {
      email: this.formLogin.value.email,
      password: this.formLogin.value.password,
    };
    this.isLoading= true;
    this.loginInvalid = false;
    this.subscription_Login = this.authService.Login(usuarioLogin).subscribe(
      (res) => {
        if (res.isSuccess == true) {
          const token = res.result.token;
          localStorage.setItem("userName", res.result.userName);
          if (token) {
            console.log("**********LOGIN COMPLETE*******");
            localStorage.setItem("token", token);
            localStorage.setItem("user", this.formLogin.value.email);
            localStorage.setItem("password", this.encriptionService.EncryptData(this.formLogin.value.password));
            
            this.router.navigate(["/callback"]);
          }
        } 
        else {
          this.isLoading = false;
          this.loginInvalid = true;
        }
      },
      (err) => {
        console.log("Error al loggearse", err);
        // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
        this.isLoading = false;
      }
    );
  }

  recoveryPasswordDialog() {
   const dialogRef = this.dialog.open(SendRecoveryPasswordDialogComponent, {
      width: '450px',
      height: '440px',
      data: { name: 'Angular' },
      panelClass: 'dialog-container-custom'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  togglePasswordVisibility(){
    this.hidePassword = !this.hidePassword;
  }
  
  isLoggedIn(){
    if (localStorage.getItem("token") != null 
        && localStorage.getItem("token") != undefined
        && localStorage.getItem("token") != ""
        && localStorage.getItem("user") != null 
        && localStorage.getItem("user") != undefined
        && localStorage.getItem("user") != ""
        ){
      this.suscription_checkAuth = this.authService.checkAuthenticated().subscribe((arg) => {
        if (arg){
          this.router.navigate(["/callback"]);
        }
      });
    }
  }
}
